import { ReactNode, useEffect, useState } from 'react';
// Modal
import ReactModal from 'react-modal';
import { ModalProvider } from 'react-modal-hook';
import { createHistory, LocationProvider } from '@reach/router';

import windowCheck from 'utils/helpers/window-check';

import Footer from 'components/footer/default';
import Head from 'components/globals/head';
import NavigationCategories from 'components/navigation/categories';
import NavigationMain from 'components/navigation/main';

import 'components/icons';

type LayoutBlogProps = {
  activeCategory?: string
  children?: ReactNode
  hidden?: boolean
  hideCategoryDescription?: boolean
  showInitFields?: boolean
}

let history: any;
if (windowCheck) {
  history = createHistory(window as any);
}

ReactModal.setAppElement('#___gatsby');

const Layout = ({ children, hidden, showInitFields, activeCategory, hideCategoryDescription }:LayoutBlogProps) => {
  const [showFields, setShowFields] = useState(true);

  useEffect(() => {
    if (showInitFields === false) {
      setShowFields(false);
    } else {
      setShowFields(true);
    }
  }, [showInitFields]);

  return (
    <div className="layout-wrapper" style={ { visibility: hidden ? 'hidden' : 'visible' } }>
      <Head />
      <LocationProvider history={ history }>
        <ModalProvider>
          <NavigationMain isBlog />
          <NavigationCategories activeCategory={ activeCategory } hideCategoryDescription = { hideCategoryDescription } />
          <div role="main" className="remove-overflow">{children}</div>
          <Footer showInitFields={ showFields } />
        </ModalProvider>
      </LocationProvider>
    </div>
  );
};

export default Layout;
